// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__207BP","content":"RecentSearches_content__3MDhg"};